import script from "./ConvertToProProxyUi.vue?vue&type=script&setup=true&lang=js"
export * from "./ConvertToProProxyUi.vue?vue&type=script&setup=true&lang=js"

import "./ConvertToProProxyUi.vue?vue&type=style&index=0&id=7ed48d10&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed48d10"]])

export default __exports__